import API_ENDPOINTS from '../config/api';
import { get, post } from '../utils/api';

/**
 * Auth API Service
 */

// Register new user
export const register = async (userData) => {
  return await post(API_ENDPOINTS.register, userData);
};

// Login user
export const login = async (credentials) => {
  return await post(API_ENDPOINTS.login, credentials);
};

// Logout user
export const logout = async () => {
  return await post(API_ENDPOINTS.logout, {});
};

// Get current user
export const getCurrentUser = async () => {
  return await get(API_ENDPOINTS.me);
};

// Request password reset link
export const forgotPassword = async (email) => {
  return await post(API_ENDPOINTS.forgotPassword, { email });
};

// Reset password with token
export const resetPassword = async (token, password) => {
  return await post(API_ENDPOINTS.resetPassword(token), { password });
};

const authService = {
  register,
  login,
  logout,
  getCurrentUser,
  forgotPassword,
  resetPassword,
};

export default authService;
